import classes from "./form-elements.module.css";

interface DropdownMenuItemProps
    extends React.LiHTMLAttributes<HTMLLIElement> {
    isActive: boolean;
    isSelected: boolean;
    children: React.ReactNode;
    index?: number;
    item?: any;
}

export const DropdownMenuItem = ({
    isActive,
    isSelected,
    children,
    // Strip downshift passthroughs that aren't valid DOM attributes; everything
    // else in `rest` (onClick/onMouseMove/role/id/aria-*) must reach the <li> so
    // clicking a suggestion actually selects it.
    index: _index,
    item: _item,
    ...rest
}: DropdownMenuItemProps) => (
    <li
        {...rest}
        className={
            `${classes.dropdownMenuItem}` +
            `${isActive ? ` ${classes.isActive}` : ""}` +
            `${isSelected ? ` ${classes.isSelected}` : ""}`
        }
    >
        {children}
    </li>
);
